import { Service, signal } from '@angular/core';

@Service()
export class Loader {
  public readonly status = signal<boolean>(false);
  private readonly transparent = signal<boolean>(false);
  public readonly isTransparent = this.transparent.asReadonly();

  public readonly equipmentBusy = signal<boolean>(false);

  public display(show = true, background?: boolean) {
    this.status.set(show);
    this.transparent.set(background === true);
  }

  public hide() {
    this.status.set(false);
  }
}
